export enum SchedulingSegment {
  SCHEDULE = 'schedule',
  EXPECTATIONS = 'expectations'
}
